import { useState, useCallback } from 'react';
import { ParticipantsDeleteCount, ParticipantsListFields } from '../types';
import { fetchApi } from '../../../../lib/fetchApi';

interface UseParticipantCountResult {
    count: number | null;
    loading: boolean;
    error: string | null;
    fetchCount: (participant: ParticipantsListFields) => Promise<number | null>;
}

export const useParticipantCount = (): UseParticipantCountResult => {

    const [count, setCount] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    /*use of useCallBack 
    The function still runs every time you call it, but React 
    doesn't create a new function object in memory on every render,
    which prevents unnecessary re-renders in child components and infinite loops in effects.*/

    const fetchCount = useCallback(async (participant: ParticipantsListFields): Promise<number | null> => {
        setLoading(true);
        setError(null);

        try {
            
            const participantDeleteItemDto = {
                id: participant.id,
                email: participant.email || '',
                phone: participant.phone || ''
            };
            const response = await fetchApi.put(`/participant/count`, participantDeleteItemDto) as ParticipantsDeleteCount;

            const fetchedCount = response.numberParicipantsDelete || 0;

            setCount(fetchedCount);
            return fetchedCount;

        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Unknown error';
            setError(errorMessage);
            setCount(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return { count, loading, error, fetchCount };
};